import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { NeedOfDisabilityService } from '@ascschool/services/category/need-of-disability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { MaritalStatusService } from '@ascschool/services/school/marital-status.service';
import { CaregiverService } from '@ascschool/services/category/caregiver.service';
import { LivingConditionService } from '@ascschool/services/category/living-condition.service';
import { LevelOfDevelopmentTypesService } from '@ascschool/services/school/level-of-development-types.service';
import { CadisInterventionStatussService } from '@ascschool/services/category/cadis-Intervention-Statuss.service';
import { NeedForEducationalSpService } from '@ascschool/services/survey/need-for-educational-sp.service';
@Component({
  selector: 'app-bao-cao-thong-ke-nkt',
  templateUrl: './bao-cao-thong-ke-nkt.component.html',
  styleUrls: ['./bao-cao-thong-ke-nkt.component.scss']
})
export class BaoCaoThongKeNKTComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef, public _authService: AuthService, public sizePageService: SizePageService,
    private authQuery: AuthQuery, public utilService: UtilsService, private service: BaocaoService,
    private caDisNeedOfDisabilitysService: NeedForEducationalSpService, private disProvincesService: ProvinceService,
    private districtService: DistrictService, private wardService: WardService,
    private typeOfDisabilityservice: TypeOfDisabilityService, private caDisEducationalStatusesService: EducationalStatusService,
    private disStudyModeService: StudyModeService, private disModesOfEducationService: ModesOfEducationService,
    private levelService: LevelService, private maritalStatusService: MaritalStatusService,
    private interventionStatusSearvice: CadisInterventionStatussService, private caregiverService: CaregiverService,
    private livingConditionService: LivingConditionService, private levelOfDevelopmentTypesService: LevelOfDevelopmentTypesService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
   }
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  @ViewChild('pageHeaderTable3', { static: false }) set content3(content3: ElementRef) {
    if (content3) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable3 = content3;
    }
  }
  $unSubscribe= new Subject();
  year: any = new Date;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  dataTable: any[] = [];
  firstRowOnPage: any;
  width: number;
  numberControl: number;
  header1Arr: any[] = [];
  header2Arr: any[] = [];
  header3Arr: any[] = [];
  keys: any[] = [];
  currentUser: any;
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  private elementPageHeaderTable3: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  listYearOld = [
    { value: 1, name: "0-5 tuổi" },
    { value: 2, name: "6-11 tuổi" },
    { value: 3, name: "12-15 tuổi" },
    { value: 4, name: "16-18 tuổi" },
    { value: 5, name: "19-35 tuổi" },
    { value: 6, name: "35-60 tuổi" },
    { value: 7, name: "Trên 60 tuổi" },
  ];
  show = false; maxHeight: number; height: number; heightPopup: number; heightPagnagation: number = 50; isCollapse = true; sum = 0;
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getDisTypeOfDisabilitysACFn: (value: any) => Observable<any>; disTypeOfDisabilitysSubscription: any; disTypeOfDisabilitysControl = new FormControl();
  getCaDisEducationalStatusessACFn: (value: any) => Observable<any>; caDisEducationalStatusesSubscription: any; caDisEducationalStatusesControl = new FormControl();
  getDisStudyModeACFn: (value: any) => Observable<any>; disStudyModeSubscription: any; disStudyModeControl = new FormControl();
  getDisModesOfEducationACFn: (value: any) => Observable<any>; disModesOfEducationSubscription: any; disModesOfEducationControl = new FormControl();
  getCaDisNeedOfDisabilitysACFn: (value: any) => Observable<any>; caDisNeedOfDisabilitysSubscription: any; caDisNeedOfDisabilitysControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getDisWardACFn: (value: any) => Observable<any>; DisWardSubscription: any; DisWardControl = new FormControl();
  getLevelACFn: (value: any) => Observable<any>; LevelSubscription: any; LevelControl = new FormControl();
  getMaritalStatusACFn: (value: any) => Observable<any>; MaritalStatusSubscription: any; MaritalStatusControl = new FormControl();
  getstudentInterventionStatusACFn: (value: any) => Observable<any>; studentInterventionStatusSubscription: any; studentInterventionStatusControl = new FormControl();
  getCaregiverACFn: (value: any) => Observable<any>; CaregiverSubscription: any; CaregiverControl = new FormControl();
  getLivingConditionACFn: (value: any) => Observable<any>; LivingConditionSubscription: any; LivingConditionControl = new FormControl();
  getLevelOfDevelopmentTypesACFn: (value: any) => Observable<any>; LevelOfDevelopmentTypesSubscription: any; LevelOfDevelopmentTypesControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.ProvinceControl.setValue({ id: res.id, text: res.provinceName });

        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });

      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
    }
    // if (this.currentUser.accountType === 1) {
    //   this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    // } else {
    //   this.commonFilter.subordinateTypeId = 0;
    // }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });
    }
    this.reload();
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.commonFilter.Gender = -1;
    this.loadDisTypeOfDisabilitys();
    this.loadCaDisEducationalStatuses();
    this.loadDisStudyMode();
    this.loadDisModesOfEducation();
    this.loadCaDisNeedOfDisabilitys();
    this.loadDisProvinces();
    this.loadLevel();
    this.loadMaritalStatus();
    this.loadstudentInterventionStatus();
    this.loadLivingCondition();
    this.loadLevelOfDevelopmentTypes();
    this.loadCaregiver();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    this.commonFilter.year = this.year;
    this.resetData();
    this.service.getRpStudentProvince(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        this.handlingData(response);
        this.width = 250 + 100 * this.header2Arr.length * 2;
        _this.loading = false;
      }, (err: any) => {
        this.resetData();
        _this.loading = false;
      }
    );
  }
  handlingData(response: any) {
    this.sum = 0;
    let rowHeader1 = [
      { id: 1, dataName: "Người cung cấp thông tin", idChild: 'nguonCapTin', colSpan: 1 },
      { id: 1, dataName: "Độ tuổi", idChild: 'doTuoi', colSpan: 1 },
      { id: 2, dataName: "Giới tính", idChild: 'gioiTinh', colSpan: 1 },
      { id: 3, dataName: "Dân tộc", idChild: 'danToc', colSpan: 1 },
      { id: 4, dataName: "Giấy chứng nhận KT", idChild: 'giayChungNhan', colSpan: 1 },
      { id: 5, dataName: "Dạng tật", idChild: 'dangTat', colSpan: 1 },
      { id: 6, dataName: "Mức độ KT", idChild: 'mucDoKt', colSpan: 1 },
      { id: 7, dataName: "Hỗ trợ giáo dục", idChild: 'hoTroGiaoDuc', colSpan: 1 },
      { id: 8, dataName: "Tình trạng giáo dục", idChild: 'tinhTrangGiaoDuc', colSpan: 1 },
      { id: 9, dataName: "Tình trạng can thiệp", idChild: 'tinhTrangCanThiep', colSpan: 1 },
      { id: 11, dataName: "Tình trạng việc làm", idChild: 'tinhTrangViecLam', colSpan: 1 },
      { id: 11, dataName: "Tình trạng hôn nhân", idChild: 'tinhTrangHonNhan', colSpan: 1 },
      { id: 12, dataName: "Đang sống tại", idChild: 'dangSongTai', colSpan: 1 },
      { id: 13, dataName: "Điều kiện kinh tế gia đình", idChild: 'dieuKienKtgd', colSpan: 1 },
    ];
    if (response.linhVucPhatTrien) {
      response.linhVucPhatTrien.forEach(element => {
        rowHeader1.push({ id: element.id, dataName: element.dataName, idChild: 'mucDoPhatTrien' + element.id, colSpan: 1 })
      });
    }
    rowHeader1.push({ id: 18, dataName: "Nhu cầu hỗ trợ, giáo dục", idChild: 'nhuCauHoTroGd', colSpan: 1 },
      { id: 19, dataName: "Biết chính sách giáo dục cho NKT", idChild: 'bietChinhSachGdcNkt', colSpan: 1 },
      { id: 21, dataName: "Sự phối hợp của cộng đồng", idChild: 'suPhoiHopCd', colSpan: 1 },
      { id: 21, dataName: "Sự phối hợp của chính quyền và ban, ngành địa phương", idChild: 'suPhoiHopCqdp', colSpan: 1 });
    let rowHeader2 = [];
    let data = [];
    let keys = Object.keys(response);

    data = response.tinhThanh;
    //map data
    data.forEach(tinhthanh => {
      this.sum += tinhthanh.total;
      keys.forEach(key => {
        if (response[key] && response[key].length > 0) {

          response[key].forEach(item => {

            let keysObj = Object.keys(item);
            let newId = key.substring(0, key.length - 2) + item[keysObj[1]];
            if (tinhthanh.id === item.provinceId && item.total) {
              tinhthanh[newId] = item.total;

            }
          });
        }
      });
    });
    //header 2
    keys.forEach(key => {
      if (key === 'mucDoPhatTrien') {
        rowHeader1.forEach(h1 => {
          if (h1.idChild.indexOf(key) !== -1) {
            let hea2array = [];
            hea2array = response[key].filter(pta => pta.ptaId === h1.id);
            h1.colSpan = hea2array.length * 2;
            hea2array.forEach(elementH2 => {
              rowHeader2.push({ dataName: elementH2.dataName, id: key + elementH2.id, colSpan: 2 });
            });
          }
        });
      } else {
        rowHeader1.forEach(h1 => {
          if (key === h1.idChild && response[key]) {
            h1.colSpan = response[key].length * 2;
            response[key].forEach(elementH2 => {
              rowHeader2.push({ dataName: elementH2.dataName, id: key + elementH2.id, colSpan: 2 });
            });
          }
          if (key === h1.idChild && response[key] === null) {
            h1.colSpan = 2;
            rowHeader2.push({ dataName: '', id: null, colSpan: 2 });
          }
        });
      }
    });
    data.push({ dataName: 'Tổng', total: this.sum });


    this.header1Arr = rowHeader1;
    this.header2Arr = rowHeader2;
    this.dataTable = data;
  }

  resetData() {
    this.dataTable = [];
    this.header1Arr = [];
    this.header2Arr = [];
    this.header3Arr = [];
    this.keys = [];
  }
  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportRpStudentProvince(this.commonFilter).subscribe((data : any) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'thttnkt.xlsx';
      link.click();
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.heightfnc();
    }, 500);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => console.log('hi'),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 250 + 100 * this.header2Arr.length * 2;
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.elementPageHeaderTable3,
      this.heightPagnagation
    );
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
  }

  clear() {
    this.year = '';
    delete this.commonFilter.YearOld;
    delete this.commonFilter.YearOld;
    delete this.commonFilter.Gender;
    delete this.commonFilter.InfoProvider;
    delete this.commonFilter.CertificateTypeId;
    delete this.commonFilter.SupportedEducation;
    delete this.commonFilter.UnderstandDisabilityPolicy;
    delete this.commonFilter.CommunityCoordination;
    delete this.commonFilter.LocalGovernmentCoordination;
    this.MaritalStatusControl.setValue(null);
    this.studentInterventionStatusControl.setValue(null);
    this.CaregiverControl.setValue(null);
    this.LivingConditionControl.setValue(null);
    this.LevelOfDevelopmentTypesControl.setValue(null);
    if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5){
      this.DisProvincesControl.setValue(null);
    }
    if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1){
      this.DistrictControl.setValue(null);
    }
    this.DisWardControl.setValue(null);
    this.disTypeOfDisabilitysControl.setValue(null);
    this.caDisEducationalStatusesControl.setValue(null);
    this.disModesOfEducationControl.setValue(null);
    this.disStudyModeControl.setValue(null);
    this.caDisNeedOfDisabilitysControl.setValue(null);
    this.LevelControl.setValue(null);
    this.reload();
  }
  loadDisTypeOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfDisabilitysACFn = (value: any) =>
      this.typeOfDisabilityservice.getSelectPaging({
        searchTerm: value, PageIndex: 1, PageSize: 100
      }).pipe(map((resp) => resp.results.length > 0
        ? resp.results.map((x) => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfDisabilitysSubscription) {
      this.disTypeOfDisabilitysSubscription = this.disTypeOfDisabilitysControl.valueChanges.subscribe(
        () => {
          this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.disTypeOfDisabilitysControl.value);
        }
      );
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisTypeOfDisabilitysACFn(control: FormControl) {
    this.disTypeOfDisabilitysControl = control;
  }

  loadCaDisEducationalStatuses() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisEducationalStatusessACFn = (value: any) =>
      this.caDisEducationalStatusesService.getSelectPaging({
        searchTerm: value, PageIndex: 1, PageSize: 100
      }).pipe(map((resp) => resp.results.length > 0
        ? resp.results.map((x) => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.caDisEducationalStatusesSubscription) {
      this.caDisEducationalStatusesSubscription = this.caDisEducationalStatusesControl.valueChanges.subscribe(
        () => {
          this.utilService.bindOrUnBindTheId(this.commonFilter, 'EducationalStatusId', this.caDisEducationalStatusesControl.value);
        }
      );
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisEducationalStatuses(control: FormControl) {
    this.caDisEducationalStatusesControl = control;
  }

  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) =>
      this.disStudyModeService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.disStudyModeSubscription) {
      this.disStudyModeSubscription = this.disStudyModeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'StudyModeId', this.disStudyModeControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.disStudyModeControl = control;
  }
  loadDisModesOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getDisModesOfEducationACFn = (value: any) =>
      this.disModesOfEducationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.disModesOfEducationSubscription) {
      this.disModesOfEducationSubscription = this.disModesOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModesOfEducationId', this.disModesOfEducationControl.value);
      }
      );
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisModesOfEducation(control: FormControl) {
    this.disModesOfEducationControl = control;
  }
  loadCaDisNeedOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisNeedOfDisabilitysACFn = (value: any) =>
      this.caDisNeedOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.caDisNeedOfDisabilitysSubscription) {
      this.caDisNeedOfDisabilitysSubscription = this.caDisNeedOfDisabilitysControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'EducationalSupportId', this.caDisNeedOfDisabilitysControl.value);
      }
      );
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisNeedOfDisabilitys(control: FormControl) {
    this.caDisNeedOfDisabilitysControl = control;
  }
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) =>
      this.disProvincesService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
      this.DisWardControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) =>
      this.districtService.getDistrictSelectPaging({
        searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
      }).pipe(map((resp) => resp.results.length > 0
        ? resp.results.map((x) => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) {
      this.loadDisWard();
      this.DisWardControl.setValue(null);
    }
  }
  loadDisWard() {
    // tslint:disable-next-line: max-line-length
    this.getDisWardACFn = (value: any) =>
      this.wardService.getWardSelectPaging({
        searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100
      }).pipe(map((resp) => resp.results.length > 0
        ? resp.results.map((x) => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisWardSubscription) {
      this.DisWardSubscription = this.DisWardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.DisWardControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisWardACFn(control: FormControl) {
    this.DisWardControl = control;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') {
      return control.value.id;
    }
    return '';
  }
  loadLevel() {
    // tslint:disable-next-line: max-line-length
    this.getLevelACFn = (value: any) =>
      this.levelService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        // tslint:disable-next-line: max-line-length
        map((resp) => resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'levelId', this.LevelControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeLevelACFn(control: FormControl) {
    this.LevelControl = control;
  }
  loadMaritalStatus() {
    this.getMaritalStatusACFn = (value: any) => this.maritalStatusService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MaritalStatusSubscription) this.MaritalStatusSubscription = this.MaritalStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'maritalStatusId', this.MaritalStatusControl.value);
    });
  }
  changeMaritalStatus(control: FormControl) {
    this.MaritalStatusControl = control;
  }
  loadstudentInterventionStatus() {
    this.getstudentInterventionStatusACFn = (value: any) => this.interventionStatusSearvice.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.studentInterventionStatusSubscription) this.studentInterventionStatusSubscription = this.studentInterventionStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'InterventionStatusId', this.studentInterventionStatusControl.value);
    });
  }
  changestudentInterventionStatus(control: FormControl) {
    this.studentInterventionStatusControl = control;
  }
  loadCaregiver() {
    this.getCaregiverACFn = (value: any) => this.caregiverService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name, isRequiredNote: x.isRequiredNote })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CaregiverSubscription) this.CaregiverSubscription = this.CaregiverControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'caregiverId', this.CaregiverControl.value);
    });
  }
  changeCaregiver(control: FormControl) {
    this.CaregiverControl = control;
  }
  loadLivingCondition() {
    this.getLivingConditionACFn = (value: any) => this.livingConditionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LivingConditionSubscription) this.LivingConditionSubscription = this.LivingConditionControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'LivingConditionId', this.LivingConditionControl.value);
    });
  }
  changeLivingCondition(control: FormControl) {
    this.LivingConditionControl = control;
  }
  loadLevelOfDevelopmentTypes() {
    this.getLevelOfDevelopmentTypesACFn = (value: any) => this.levelOfDevelopmentTypesService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelOfDevelopmentTypesSubscription) this.LevelOfDevelopmentTypesSubscription = this.LevelOfDevelopmentTypesControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'LevelOfDevelopmentTypeId', this.LevelOfDevelopmentTypesControl.value);
    });
  }
  changeLevelOfDevelopmentTypes(control: FormControl) {
    this.LevelOfDevelopmentTypesControl = control;
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
